define((require) => {
    "use strict";

    var template   = require("ui/editor/sceneLoadingScreen/UploadBarView.tpl"),
        Marionette = require("marionette");

    return Marionette.ItemView.extend({

        template: template,

        className: "upload-bar-block",

        ui: {
            container: ".loading-bar-container",
            loadingBar: ".loading-bar"
        },

        modelEvents: {
            "change:progress": "_changeProgressHandler"
        },

        _changeProgressHandler: function(model, progress) {
            this._updateLoadingBar(progress);
        },

        /**
         * Updates the loading bar.
         *
         * @param {Number} progress - between 0 and 1 - how far are we?
         */
        _updateLoadingBar: function(progress) {
            this.ui.loadingBar.width(progress * 100 + "%");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/sceneLoadingScreen/UploadBarView.js